import { useQuery } from "@tanstack/react-query";

import { HttpQuery } from "@Types/http";
import { getApplications } from "@Http/deals";

const useGlobalSearch = (query: HttpQuery) => {
  const {
    data: deals,
    isLoading: dealsAreLoading,
    error: dealsError,
  } = useQuery({
    queryKey: ["deals-global-search", query ?? {}],
    queryFn: getApplications(query),
    enabled: !!Object.keys(query)?.length,
  });
  return {
    data: { deals: deals?.docs ?? [] },
    isLoading: { dealsAreLoading },
    error: { dealsError },
  };
};
export default useGlobalSearch;
